import { render, staticRenderFns } from "./Btn.vue?vue&type=template&id=1a4b6eda&scoped=true"
import script from "./Btn.vue?vue&type=script&lang=js"
export * from "./Btn.vue?vue&type=script&lang=js"
import style0 from "./Btn.vue?vue&type=style&index=0&id=1a4b6eda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a4b6eda",
  null
  
)

export default component.exports